import { GET_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";
 
export const GetVaccineBrandList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/VaccineBrand/GetList?` + params, null);